export default "__VITE_ASSET__CUQV6DMb__"